import React from 'react';
import {
  Box,
  Chip,
  Divider,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import {
  formatDate,
  getOrderCode,
  numberValue,
  productLabel,
  supplierLabel,
  variantModeLabel,
} from './selloutUtils';

export default function SellOutPromiseSummary({
  supplier,
  form,
  selectedOrders,
  lines,
}) {
  return (
    <Stack spacing={2}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
        <Box sx={{ minWidth: 220 }}>
          <Typography variant="caption" color="text.secondary">Proveedor</Typography>
          <Typography variant="body1" fontWeight={700}>{supplierLabel(supplier)}</Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Fecha</Typography>
          <Typography variant="body1">{formatDate(form.date)}</Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Referencia</Typography>
          <Typography variant="body1">{form.reference || '-'}</Typography>
        </Box>
      </Stack>

      <Divider />

      <Box>
        <Typography variant="subtitle2" fontWeight={700} gutterBottom>
          Ordenes base
        </Typography>
        <Stack direction="row" flexWrap="wrap" gap={1}>
          {(selectedOrders || []).map((order) => (
            <Chip key={order.id} label={getOrderCode(order)} size="small" />
          ))}
        </Stack>
      </Box>

      <Box>
        <Typography variant="subtitle2" fontWeight={700} gutterBottom>
          Lineas
        </Typography>
        <Table size="small" sx={{ tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell width={54}>#</TableCell>
              <TableCell>Productos base</TableCell>
              <TableCell>Producto esperado</TableCell>
              <TableCell width={150}>Modo</TableCell>
              <TableCell width={120} align="right">Base</TableCell>
              <TableCell width={120} align="right">Esperada</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(lines || []).map((line, index) => {
              const baseTotal = (line.base_products_payload || []).reduce(
                (sum, row) => sum + numberValue(row.quantity_base),
                0
              );
              return (
                <TableRow key={line.client_id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <Stack spacing={0.25}>
                      {(line.base_products_payload || []).map((row) => (
                        <Typography key={row.key} variant="body2" noWrap title={`${row.order_code} - ${row.product_code} ${row.product_description}`}>
                          {row.order_code} - {row.product_code} {row.product_description}
                        </Typography>
                      ))}
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" noWrap title={productLabel(line.expected_product)}>
                      {line.expected_product ? productLabel(line.expected_product) : '-'}
                    </Typography>
                  </TableCell>
                  <TableCell>{variantModeLabel(line.expected_variant_mode)}</TableCell>
                  <TableCell align="right">{baseTotal}</TableCell>
                  <TableCell align="right">{numberValue(line.expected_qty)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    </Stack>
  );
}
